import { motion } from 'framer-motion';
import { ArrowRight, Check } from 'lucide-react';
import { buildSignupUrl } from '../../lib/signupUrl';

const FinalCTA = () => {
  const signupUrl = buildSignupUrl();

  return (
    <section className="py-24 px-6 relative overflow-hidden" data-testid="final-cta-section">
      {/* Background Glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-primary/15 rounded-full blur-[150px]"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="text-center"
        >
          {/* Headline */}
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-heading font-black text-white mb-6 leading-tight">
            Your next blog post
            <br />
            <span className="text-gradient">deserves to be seen.</span>
          </h2>

          <p className="text-gray-400 text-lg md:text-xl max-w-2xl mx-auto mb-10">
            Join <span className="text-white font-semibold">10,000+ creators</span> who turned their writing 
            into a video audience — starting with one free video today.
          </p>

          {/* CTA */}
          <a
            href={signupUrl}
            className="inline-flex items-center gap-3 bg-brand-primary hover:bg-brand-primary-hover text-surface-base px-10 py-5 rounded-full text-xl font-bold transition-all duration-300 hover:-translate-y-1 glow-primary-strong"
            data-testid="final-cta-button"
          >
            Start free trial
            <ArrowRight className="w-6 h-6" />
          </a>

          {/* Sub-info */}
          <div className="flex flex-wrap justify-center gap-6 mt-8 text-sm text-gray-400">
            <span className="flex items-center gap-2"><Check className="w-4 h-4 text-brand-primary" /> Ready in 2 minutes</span>
            <span className="flex items-center gap-2"><Check className="w-4 h-4 text-brand-primary" /> No watermarks on paid plans</span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
